import { InputProps,Theme } from '@mui/material';
import { ToastType } from './requests/Enums';
import { PreOrderData } from './Interfaces';

export const getMaximumRowsPerPage = ():number => 10;

export const getAppName = () => "Koordine";

export const getLocalStorageAuthVariableName = () => `${getAppName()}_auth`;

export const getInputLabelProps = () => ({style: {fontSize: '0.8em'}});

export const autocompletePopperStyles = (theme: Theme) => ({
    popper: {
      maxWidth: 'fit-content',
    },
  });
  
  export const getInputProps = () => ({
    style: { fontSize: '0.8em', padding: 8 },
  });

  export const getAutocompleteInputProps = (inheritedInputProps: InputProps) => ({
    ...inheritedInputProps,
    style: { fontSize: '.8em', padding: 8 },
  });
  
  export const getDatePickerInputProps = (inheritedInputProps: InputProps) => ({
    ...inheritedInputProps,
    style: { fontSize: '.8em', padding: 5 },
  });

  export const parseJWT = (token: string): any => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  export const getDefaultHeaders = (token: string, managementId?: string, page?: number, filters?: any, filtersPropertyName?: any) => {
    return {
      headers:{
        ApplicationId: getAppName(),
        authenticate: `bearer ${token}`,
        ManagementId: managementId,
        pagination: page,
        [filtersPropertyName ?? "Filters"]: filters ? JSON.stringify(filters) : undefined,
      }
    };
  }

  export const getAlertType = (toastType: ToastType): any => {
    switch(toastType){
        case ToastType.warning:
            return "warning";
        case ToastType.error:
            return "error";
        default:
            return "info";
    }
  }

  export const getOperationalStatusCodeById = (operationalStatusId: number): string => {
    switch(operationalStatusId){
      case -1:
        return "TOTALSERVICEORDERS";
      case 0:
        return "CANCELED";
      case 1:
        return "TOEXECUTE";
      case 2:
        return "INEXECUTION";
      case 3:
        return "PENDINGREVIEW";
      case 4:
        return "FINISHED";
      case 5:
        return "NOTFINISHED";
      default:
        return "NODATA";
    }
  }

  export const getOperationalStatusBackColorById = (operationalStatusId: number): string => {
    switch(operationalStatusId){
      case 0:
        return "crimson";
      case 2:
        return "#21469C";
      case 3:
        return "#E0CD5F";
      case 4:
        return "#0CAC1F";
      case 5:
        return "#EE2F56";
      default:
        return "lightgray";
    }
  }

  export const getOperationalStatusFontColorById = (operationalStatusId: number): string => {
    switch(operationalStatusId){
      case 0:
        return "crimson";
      case 1:
      case 3:
        return 'rgba(0,0,0,0.7)';
      default:
        return "#FFFFFF";
    }
  }

  export const getIsOutlinedByOperationalStatusId = (operationalStatusId: number): boolean => {
    return operationalStatusId === 0;
  }

  export const getDateInYYYYMMDDWithoutTimeFormat = (date: Date, utc?: boolean, final?:boolean) => {
    const ye = utc
      ? date.getUTCFullYear()
      : new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const mo = utc
      ? convertToValueWithZero(date.getUTCMonth() + 1)
      : new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    const da = utc
      ? convertToValueWithZero(date.getUTCDate())
      : new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    return `${ye}-${mo}-${da} ${!!final ? '23:59:59' : '00:00:00'}`;
  };

  export const GetDateRegional = (date: Date) => {
    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };

  export const getDateInYYYYMMDDWithUTC = (date: Date) => {
    const ye = date.getUTCFullYear();
    const mo =convertToValueWithZero(date.getUTCMonth() + 1);
    const da = convertToValueWithZero(date.getUTCDate());
    const hh = convertToValueWithZero(date.getUTCHours());
    const mm = convertToValueWithZero(date.getUTCMinutes());
    const ss = convertToValueWithZero(date.getUTCSeconds());
    return `${ye}-${mo}-${da} ${hh}:${mm}:${ss}`;
  };

  export const convertToValueWithZero = (value: number) => {
    if (value < 10) {
      return `0${value}`;
    }
  
    return value;
  };

  export const getDateInYYYYMMDDHHmmss = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return `${year}-${convertToValueWithZero(month)}-${convertToValueWithZero(
      day
    )} ${convertToValueWithZero(hours)}:${convertToValueWithZero(
      minutes
    )}:${convertToValueWithZero(seconds)}`;
  };

  export const getDateInYYYYMMDDFormat = (date: Date) => {
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    return `${ye}-${mo}-${da}`;
  };

  export const generatePreOrderNotificationEmail = (preOrder: PreOrderData, code:string, user:string): string => {
    return `<html><h3>Nueva Pre-Orden ${code} - ${user}</h3><p><strong>Información general:</strong></p><p><ul><li><c>Tipo de orden de servicio:</strong> ${preOrder.ProductBrand?.Name}</li><li><strong>Expediente:</strong> ${preOrder.ProductType?.Name}</li><li><strong>Estado:</strong> Pendiente</li></ul></p><p><strong>Información del cliente:</strong></p><p><ul><li><strong>Tipo de identificación:</strong> ${preOrder.ClientIdentificationType}</li><li><strong>Identificación: </strong>${preOrder.ClientIdentification}</li><li><strong>Nombre del cliente:</strong> ${preOrder.ClientName}</li><li><strong>Departamento:</strong> ${preOrder.State?.Name}</li><li><strong>Ciudad:</strong> ${preOrder.City?.Name}</li><li><strong>Dirección:</strong> ${preOrder.ClientAddress}</li><li><strong>Teléfono:</strong> ${preOrder.ClientPhoneNumber}</li><li><strong>Correo electrónico:</strong> ${preOrder.ClientEmail}</li></ul></p><p><strong>Datos del producto:</strong></p><p><ul><li><strong>Modelo: </strong> ${preOrder.ProductModel}</li><li><strong>Serial: </strong> ${preOrder.ProductSerial}</li><li><strong>Número de Factura: </strong> ${preOrder.BillNumber}</li><li><strong>Fecha de Factura: </strong> ${preOrder.BillDate ? getDateInYYYYMMDDWithoutTimeFormat(new Date(preOrder.BillDate!)) : 'No hay datos'}</li></ul></p><p><strong>Detalle del servicio:</strong></p><p>${preOrder.ProductLocation} - ${preOrder.Observation}</p></html>`
  }